import React from 'react';

const Blogs = () => {
    return (
        <div className='mt-20'>
            <h1 className='text-5xl font-bold pl-20 text-rose-600'>Comming Soon.....</h1>
        </div>
    );
};

export default Blogs;
